import { getToken } from "./AuthUtils";
import axios, { AxiosRequestConfig } from "axios";

export const baseAPIAuthUrl: string = process.env.REACT_APP_BASE_API_AUTH_URL || "";
export const baseAPIUrl: string = process.env.REACT_APP_BASE_API_URL || "";
export const baseOcelotUrl: string = process.env.REACT_APP_BASE_OCELOT_URL || "";

export const setDefaultHeader = () => {
    axios.interceptors.request.use((config: AxiosRequestConfig) => {
        const token = getToken();
        if (token) {
            //axios.defaults.headers.common['Authorization'] = token;
            if (config && config.headers) {
                config.headers.Authorization = token;
                config.headers.Accept = "application/json";
            }
        }
        return config;
    });
}